import { render, staticRenderFns } from "./compute-type-details.vue?vue&type=template&id=4dae9f66&scoped=true"
import script from "./compute-type-details.vue?vue&type=script&lang=js"
export * from "./compute-type-details.vue?vue&type=script&lang=js"
import style0 from "./compute-type-details.vue?vue&type=style&index=0&id=4dae9f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae9f66",
  null
  
)

export default component.exports